"use client"

// src/components/link-box.ts
var LinkBox = {
  baseStyle: {
    container: {},
    overlay: {
      outline: 0,
      _focusVisible: {
        _before: {
          boxShadow: "outline"
        }
      }
    }
  }
};

export {
  LinkBox
};
//# sourceMappingURL=chunk-FWBELN6F.mjs.map